"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-unassigned-import */
require("dayjs/locale/ar");
require("dayjs/locale/cy");
require("dayjs/locale/da");
require("dayjs/locale/de");
require("dayjs/locale/el");
require("dayjs/locale/en-gb");
require("dayjs/locale/en");
require("dayjs/locale/es");
require("dayjs/locale/fi");
require("dayjs/locale/fr");
require("dayjs/locale/he");
require("dayjs/locale/hi");
require("dayjs/locale/hu");
require("dayjs/locale/it");
require("dayjs/locale/ja");
require("dayjs/locale/ko");
require("dayjs/locale/lt");
require("dayjs/locale/nb");
require("dayjs/locale/nl-be");
require("dayjs/locale/nl");
require("dayjs/locale/pl");
require("dayjs/locale/pt-br");
require("dayjs/locale/pt");
require("dayjs/locale/ru");
require("dayjs/locale/sv");
require("dayjs/locale/vi");
require("dayjs/locale/zh-cn");
require("dayjs/locale/zh-tw");
//# sourceMappingURL=localesList.js.map